/**
 * VistoeraTASK-00573 — tab ↔ session identity binding.
 *
 * The session cookie is shared by every tab of the browser. After a login /
 * logout / account switch in one tab, any other still-open tab would keep
 * rendering the OLD account while its requests silently carried the NEW
 * cookie. Every SaaS call therefore declares which user this tab renders;
 * the backend answers 409 `session_identity_changed` on a mismatch instead of
 * executing the request as someone else, and the tab resyncs.
 *
 * Module-level (not React state) so both axios clients can read it
 * synchronously; `AuthProvider` writes it during render, before any child
 * effect can fire a request.
 */

export const EXPECTED_SESSION_USER_HEADER = 'X-Vst-Session-User'
export const SESSION_IDENTITY_CHANGED_CODE = 'session_identity_changed'
export const SESSION_IDENTITY_CHANGED_EVENT = 'vistoera:session-identity-changed'

let expectedSessionUserId: string | null = null

export function setExpectedSessionUser(userId: string | null): void {
  expectedSessionUserId = userId
}

export function getExpectedSessionUser(): string | null {
  return expectedSessionUserId
}

export function attachExpectedSessionUser<T extends { headers?: unknown }>(config: T): T {
  if (expectedSessionUserId) {
    config.headers = config.headers ?? {}
    ;(config.headers as Record<string, string>)[EXPECTED_SESSION_USER_HEADER] = expectedSessionUserId
  }
  return config
}

export function reportSessionIdentityChanged(status: number | undefined, code: unknown): void {
  if (status === 409 && code === SESSION_IDENTITY_CHANGED_CODE && typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SESSION_IDENTITY_CHANGED_EVENT))
  }
}
